<template>
  <v-container fluid class="">
    <v-row justify="center">
      <v-col cols="12">
        <v-card elevation="4" class="rounded-lg">
          <v-card-title class="bg-primary text-white text-h5 text-center py-4">
            {{ isEditing ? "Edit Salary Component" : "Add Salary Component" }}
          </v-card-title>

          <v-card-text class="pa-6">
            <v-form @submit.prevent="submit">
              <v-row>
                <!-- Name -->
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Component Name *"
                    variant="outlined"
                    v-model="name.value.value"
                    :error-messages="name.errorMessage.value"
                    density="comfortable"
                    prepend-inner-icon="mdi-format-title"
                  />
                </v-col>

                <!-- Type -->
                <v-col cols="12" md="6">
                  <v-select
                    label="Type *"
                    variant="outlined"
                    v-model="type.value.value"
                    :items="[
                      { title: 'Allowance', value: 'allowance' },
                      { title: 'Deduction', value: 'deduction' }
                    ]"
                    :error-messages="type.errorMessage.value"
                    density="comfortable"
                    prepend-inner-icon="mdi-tag"
                  />
                </v-col>

                <!-- Default Value -->
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Default Value"
                    type="number"
                    variant="outlined"
                    v-model="default_value.value.value"
                    :error-messages="default_value.errorMessage.value"
                    density="comfortable"
                    prepend-inner-icon="mdi-cash"
                  />
                </v-col>

                <!-- Percentage Switch -->
                <v-col cols="12" md="3" class="d-flex align-center">
                  <v-switch
                    label="Percentage"
                    color="primary"
                    v-model="is_percentage.value.value"
                    hide-details
                  ></v-switch>
                </v-col>

                <v-col cols="12" md="3" class="d-flex align-center">
                  <v-switch
                    label="Status"
                    color="primary"
                    v-model="status.value.value"
                    hide-details
                  ></v-switch>
                </v-col>

                <!-- Remarks -->
                <v-col cols="12">
                  <v-textarea
                    label="Remarks"
                    variant="outlined"
                    v-model="remarks.value.value"
                    density="comfortable"
                    rows="3"
                    maxlength="255"
                    counter
                  />
                </v-col>
              </v-row>

              <v-card-actions class="justify-end mt-4">
                <v-btn
                  color="grey"
                  variant="flat"
                  size="large"
                  @click="resetFormAction"
                >
                  Reset
                </v-btn>

                <v-btn
                  color="primary"
                  variant="flat"
                  size="large"
                  type="submit"
                  :loading="loading"
                >
                  {{ isEditing ? "Update" : "Save" }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useForm, useField } from "vee-validate";
import * as yup from "yup";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { ref, onMounted } from "vue";
import { toast } from "vue3-toastify";

export default {
  name: "AddSalaryComponent",

  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const loading = ref(false);

    // Check Editing
    const isEditing = ref(false);

    // Validation Setup
    const { handleSubmit, resetForm, setValues } = useForm({
      validationSchema: yup.object({
        name: yup.string().required("Component name is required"),
        type: yup.string().required("Type is required"),
        default_value: yup.number().nullable(),
        is_percentage: yup.boolean(),
        status: yup.boolean().nullable(),
        remarks: yup.string().nullable(),
      }),
    });

    const name = useField("name");
    const type = useField("type");
    const default_value = useField("default_value");
    const is_percentage = useField("is_percentage");
    const status = useField("status");
    const remarks = useField("remarks");

    // Load Editing Data
    onMounted(() => {
      const editData = store.getters.editingsalaryComponent;

      if (editData && route.query.id) {
        isEditing.value = true;

        setValues({
          name: editData.name,
          type: editData.type,
          default_value: editData.default_value,
          is_percentage: editData.is_percentage == 1,
          status: editData.status == 1,
          remarks: editData.remarks,
        });
      }
    });

    // Submit
    const submit = handleSubmit((values) => {
      loading.value = true;

      const payload = {
        id: route.query.id ?? null,
        name: values.name,
        type: values.type,
        default_value: values.default_value,
        is_percentage: values.is_percentage ? 1 : 0,
        status: values.status ? 1 : 0,
        remarks: values.remarks,
      };

      store
        .dispatch("saveUpdateSalaryComponent", payload)
        .then((res) => {
            store.dispatch('salaryComponentList');
            toast.success(res.data.message);
            router.push({ name: "salary-component-record" });
        })
        .catch((err) => {
          toast.error(err.response?.data?.message || "Failed");
        })
        .finally(() => (loading.value = false));
    });

    const resetFormAction = () => {
      resetForm();
    };

    return {
      name,
      type,
      default_value,
      is_percentage,
      status,
      remarks,
      submit,
      resetFormAction,
      loading,
      isEditing,
    };
  },
};
</script>

<style scoped>
</style>
